import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a1a4694"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-submit-div" }
const _hoisted_2 = { class: "submit_div" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Submit My Review")

import { ref, inject } from 'vue';
import publicComment from '@/components/comment/public-comment.vue'
import { useRouter, useRoute } from "vue-router";
import { v4 as uuidv4 } from 'uuid';
import { Toast } from 'vant'
import Header from '@/components/header/header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'commentSubmit',
  setup(__props) {

const router: any = useRouter();
const route: any = useRoute()
const $http: any = inject("$http");
const isSubmit = ref(false)
const submit_click_fn = () => {
  isSubmit.value = true
  // setTimeout(() => {
  //   isSubmit.value = false
  // }, 2000);
}
const act_id = route.query.id ? route.query.id.toString() : ''
const record_id = route.query.record_id ? route.query.record_id.toString() : ''
const paramsData = {
  userId: common.getStorage('user_info') ? common.getStorage('user_info').id.toString() : '',
  orderId: uuidv4(),
  commentObjectId: act_id,
  commentObjectType: "9",
  isAnonymous: "0",
  languageCode: 'ke',
  extContents: JSON.stringify({
    buyerAvatarUrl: common.getStorage('user_info') ? common.getStorage('user_info').avatar_url.toString() : '',
    buyerName: common.getStorage('user_info') ? (
       common.getStorage('user_info').name ? common.getStorage('user_info').name.toString() : common.getStorage('user_info').username.toString()
    ) : '',
    commentCreatedAt: new Date().getTime()
  })
}
try {
  window.appBean.setShareIconVisible(0) // 隐藏APP的头部分享
} catch (error) {}
const callback_fn = async () => {
  let params: any = {
    lotteryId: act_id,
  }
  params['record_id'] = record_id ? record_id : 0
  await $http.getUpdateLuckyDrawCommentRecord(params).then((res:any) => {
    if (res.code === 200) {
      Toast('Submit success!')
      setTimeout(() => {
        router.go(-1)
      }, 200);
    } else {
      Toast.fail({
        message: res.message,
        duration: 5000,
        className: 'tunetable_error_msg_div'
      })
    }
  })
}

 

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      title: "Luck Draw",
      backgroundColor: "white",
      fontColor: "#303133"
    }),
    _createVNode(publicComment, {
      isSubmit: isSubmit.value,
      "onUpdate:isSubmit": _cache[0] || (_cache[0] = ($event: any) => ((isSubmit).value = $event)),
      textAreaCon: "",
      uploadPath: 'tunetable/comment/',
      title_name: "Write down how you feel about the event",
      accept: "image/*",
      paramsData: paramsData,
      content_placeholder: "Say something about......(For example: tell us what you think about the event and prizes)",
      exclusiveFn: callback_fn
    }, null, 8, ["isSubmit"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_button, {
        onClick: submit_click_fn,
        class: "submit_btn",
        block: "",
        type: "danger"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ])
  ]))
}
}

})